export const defaultTitle = (title) => `${title} | Traineron.com`;
export const trainerPanelTitle = (title) => defaultTitle(`${title} - Panel Trenera`)
export const playerPanelTitle = (title) => defaultTitle(`${title} - Panel Sportowca`)
export const clubPanelTitle = (title) => defaultTitle(`${title} - Panel Klubu`)


//TODO - add more beautiful title && language support
